import { OrderBookingData } from 'entities/orders/model/types';

export const existsChanges = (bookingData: OrderBookingData, participants_count: number | undefined) => {
	return (
		bookingData.participants_count !== participants_count ||
		bookingData.notes ||
		bookingData.prepayment_amount ||
		bookingData.person?.name ||
		bookingData.tags.length ||
		bookingData.resources.length
	);
};
